import React, { Component } from "react";
import { Link } from "react-router-dom";

import styles from "./NewProductItem.module.css";
import Language from "../utils/Language";
import Routes from "../constants/routes.json";

class NewProductItem extends Component {
  render() {
    return (
      <section className={styles.Hero}>
        <div className={styles.HeroLeft}>
          <span className={styles.Eyebrow}>
            {Language.GetString("hero_eyebrow")}
          </span>
          <h1 className={styles.Title}>
            {Language.GetString("hero_title_a")}{" "}
            <span className={styles.TitleAccent}>
              {Language.GetString("hero_title_b")}
            </span>
          </h1>
          <p className={styles.Subtitle}>
            {Language.GetString("hero_subtitle")}
          </p>
          <div className={styles.CtaRow}>
            <Link to={Routes.games} className={styles.CtaPrimary}>
              {Language.GetString("hero_cta_primary")} →
            </Link>
            <Link to={Routes.dev} className={styles.CtaSecondary}>
              {Language.GetString("hero_cta_secondary")}
            </Link>
          </div>
        </div>

        <div className={styles.HeroRight}>
          <div className={styles.FeatureCard}>
            <span className={styles.FeatureCardGlow} />
            <span className={styles.FeatureLabel}>
              {Language.GetString("featured_label")}
            </span>
            <div className={styles.FeatureMediaWrap}>
              <video
                poster="/img/game_synonym/video_trailer_thumb.jpg"
                className={styles.FeatureVideo}
                src="/img/game_synonym/video_trailer.mp4"
                controls
                playsInline
              >
                {Language.GetString("featured_trailer_error")}
              </video>
            </div>
            <div className={styles.FeatureBody}>
              <img
                className={styles.FeatureSymbol}
                alt=""
                src="/img/game_synonym/symbol.jpg"
              />
              <div className={styles.FeatureInfo}>
                <div className={styles.FeatureName}>
                  Synonym — Ein anderes Wort für
                </div>
                <div className={styles.FeatureMeta}>Google Play · Free</div>
              </div>
              <a
                href="https://play.google.com/store/apps/details?id=de.uelstudios.synonym"
                className={styles.FeatureBtn}
                target="_blank"
                rel="noreferrer"
              >
                {Language.GetString("featured_cta")}
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default NewProductItem;
